export default __webpack_public_path__ + "static/media/au.97435dd8.svg";